<template>
  <div
    class="tw-card w-full"
    :class="{
      'p-4': !noPadding,
      'shadow': !flat,
      '--rounded': !flat,
      'bg-white text-black': !transparent && !darkMode,
      '--dark-mode': darkMode
    }"
    style="height: max-content"
  >
    <slot />
  </div>
</template>

<script>
export default {
  name: "TwCard",
  props: {
    noPadding: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    transparent: {
      type: Boolean,
      default: false
    },
    darkMode: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped>
/* TODO: Account for below on tw-card or just hard code on placeholders cards */
.tw-card.--dark-mode {
  background: #242526;
  color: #fff;
}
.tw-card.--dark-mode .text-gray-500 {
  color: #9D9D9D;
}
.tw-card.--dark-mode .text-primary {
  color: #fff;
}
.tw-card.--rounded {
  border-radius: 7px;
}
</style>